import { FC, useCallback } from 'react';

import { Chip, Option } from '@beeline/design-system-react/extracted-styles';

import clsx from 'clsx';
import { Floor } from 'src/api/types';

import classes from './FloorChips.module.scss';

export type FloorChipItem = Option<Floor>;

export const toFloorChipItem = (
  floor: Floor | undefined,
): FloorChipItem | undefined =>
  floor && {
    id: floor.floorId,
    value: floor,
  };

export const toFloor = (item: FloorChipItem | undefined): Floor | undefined =>
  item?.value;

export interface FloorChipProps {
  floor: FloorChipItem;
  active: boolean;
  onClick: (floor: FloorChipItem) => void;
}

const FloorChip: FC<FloorChipProps> = ({ floor, active, onClick }) => {
  const handleClick = useCallback(() => {
    onClick(floor);
  }, [floor, onClick]);

  return (
    <div className={classes.floor}>
      <Chip label={floor.value.title} active={active} onClick={handleClick} />
    </div>
  );
};

export interface FloorChipsProps {
  activeFloor: FloorChipItem | undefined;
  setActiveFloor: (floor: FloorChipItem) => void;
  floors: FloorChipItem[];
  testId?: string;
}

export const FloorChips: FC<FloorChipsProps> = ({
  floors,
  activeFloor,
  setActiveFloor,
  testId,
}) => {
  if (!activeFloor) return null;

  return (
    <div
      className={clsx(classes.container, !floors.length && classes.hidden)}
      data-testid={testId}
    >
      <div className={classes.floors}>
        {floors.map(floor => (
          <FloorChip
            key={floor.id}
            floor={floor}
            onClick={setActiveFloor}
            active={floor.id === activeFloor.id}
          />
        ))}
      </div>
    </div>
  );
};
